import React from 'react';
import './index.less';
import { isMobile } from 'utils';
import { createRoot } from 'react-dom/client';
import { httpGet } from '@qxwz/http-client';

function EnApp({ default: App }) {
    const container = document.getElementById('root');
    const root = createRoot(container);
    httpGet('/bffportal/ok');
    root.render(
        <React.StrictMode>
            <App />
        </React.StrictMode>,
    );
}

if (isMobile()) {
    import(/* webpackChunkName: "m" */ './mobile/app').then(EnApp);
} else {
    import(/* webpackChunkName: "pc" */ './pc/app').then(EnApp);
}
